export default __webpack_public_path__ + "static/media/ic_exam_info_pause.d5d747c8.svg";